module.exports = __webpack_public_path__ + "img/SurveyClient.497d8a72.png";